export default __webpack_public_path__ + "static/media/ARTBnk_July_2021_Market_Report.a572b434.pdf";